module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetHigh@2x.5fcb900.jpg";